import * as constants from '../constants/jobDetails-constants'
import {
    JobItems,
    PublishedJobParams,
    ComplimentsNumber,
    Slots,
    Bid,
    Job,
    AttachmentParams
} from '../types'
import { AdditionalItem } from '../types/AdditionalItem'

export interface SetJobDetailsAction {
    type: string
    address?: string
    latLng?: any
    id?: string
    msaId?: string
    note?: string
    futureDateFrom?: number
    futureDateTo?: number
    jobItems?: JobItems[]
    areItemsOutside?: boolean
    areItemsInside?: boolean
    amount?: number
    name?: string
    isElevatorNeeded?: boolean
    areStairsNeeded?: boolean
    files?: Array<any>
    jobCategories?: Array<any>
    selectedJobCategory?: string
    subCategories?: Array<any>
    time?: {
        time: number
        futureTime: number
        isFuture: number
        minTime: number
    }
    jobId?: string
    providerId?: string
    status?: string
    currentLocation?: { lat: number; lng: number }
    zipCode?: string
    additionalItem?: AdditionalItem
    marks?: any
    apartmentNumber?: string
    statusChangedOnWeb?: boolean
    minHeight?: number
    complimentsNumber?: ComplimentsNumber[]
    isRescheduling?: boolean
    slots?: Slots[]
    chips?: String[]
    isJobTimeInfoShown?: boolean
    currentBids?: Bid[]
    job?: Job
    attachments?: AttachmentParams[]
}

export interface SetPublishedJobParamsAction {
    type: string
    confirmed: boolean
    hours: number
    minutes: number
    seconds: number
    createDate: number
    timeKeeping: number
    timeStopBidding: number
    secondTimeKeeping: number
    biddingActiveDate: number
}

export type JobDetailsActions = SetJobDetailsAction
export type PublishedJobParamsAction = SetPublishedJobParamsAction

export function setBids(bids: Bid[]): SetJobDetailsAction {
    return {
        type: constants.SET_BIDS,
        currentBids: bids
    }
}

export function setAddress(address: any): SetJobDetailsAction {
    return {
        type: constants.ADDRESS,
        address: address
    }
}

export function setCoords(latLng: any) {
    return {
        type: constants.COORDINATES,
        latLng
    }
}

export function selectJobCategory(
    name: string,
    id: string
): SetJobDetailsAction {
    return {
        type: constants.SELECT_JOB_CATEGORY,
        name,
        id
    }
}

export function addComment(note: string): SetJobDetailsAction {
    return {
        type: constants.ADD_COMMENT,
        note
    }
}

export function setFutureDateFrom(futureDateFrom: number): SetJobDetailsAction {
    return {
        type: constants.FUTURE_DATE_FROM,
        futureDateFrom: futureDateFrom
    }
}

export function setFutureDateTo(futureDateTo: number): SetJobDetailsAction {
    return {
        type: constants.FUTURE_DATE_TO,
        futureDateTo: futureDateTo
    }
}

export function setBagsNumber(jobItems: JobItems[]): SetJobDetailsAction {
    return {
        type: constants.JOB_ITEMS,
        jobItems
    }
}

export function setItemsOutside(areItemsOutside: boolean) {
    return {
        type: constants.ITEMSOUTSIDE,
        areItemsOutside
    }
}

export function setItemsInside(areItemsInside: boolean) {
    return {
        type: constants.ITEMSINSIDE,
        areItemsInside
    }
}

export function setPublishedJobParams(publishedJobParams: PublishedJobParams) {
    return {
        type: constants.PUBLISHED_JOB_PARAMS,
        hours: publishedJobParams.hours,
        minutes: publishedJobParams.minutes,
        seconds: publishedJobParams.seconds,
        confirmed: publishedJobParams.confirmed,
        createDate: publishedJobParams.createDate,
        timeKeeping: publishedJobParams.timeKeeping,
        timeStopBidding: publishedJobParams.timeStopBidding,
        secondTimeKeeping: publishedJobParams.secondTimeKeeping,
        biddingActiveDate: publishedJobParams.biddingActiveDate
    }
}

export function setAmount(amount: number) {
    return {
        type: constants.AMOUNT,
        amount
    }
}

export function setMsaId(msaId: string) {
    return {
        type: constants.MSAID,
        msaId
    }
}

export function setElevatorUse(isElevatorNeeded: boolean) {
    return {
        type: constants.IS_ELEVATOR_NEEDED,
        isElevatorNeeded
    }
}

export function setStairsNeeded(areStairsNeeded: boolean) {
    return {
        type: constants.ARE_STAIRS_NEEDED,
        areStairsNeeded
    }
}

export function setAttachments(files: Array<any>) {
    return {
        type: constants.ATTACHMENTS,
        files
    }
}

export function setJobCategories(jobCategories: Array<any>) {
    return {
        type: constants.JOB_CATEGORIES,
        jobCategories
    }
}

export function setSelectedJobCategory(selectedJobCategory: string) {
    return {
        type: constants.SELECTED_JOB_CATEGORY,
        selectedJobCategory
    }
}

export function setSubCategories(subCategories: Array<any>) {
    return {
        type: constants.SUB_CATEGORIES,
        subCategories
    }
}

export function setTime(time: {
    time: number
    futureTime: number
    isFuture: number
    minTime: number
}) {
    return {
        type: constants.TIME,
        time
    }
}

export function setJobId(jobId: string) {
    return {
        type: constants.JOB_ID,
        jobId
    }
}

export function setJobStatus(status: string) {
    return {
        type: constants.STATUS,
        status
    }
}
export function setOriginatedFrom(id: string) {
    return {
        type: constants.ORIGINATED_FROM,
        id
    }
}

export function setProviderId(providerId: string) {
    return {
        type: constants.SET_PROVIDER_ID,
        providerId
    }
}

export function removeJobDetails() {
    return {
        type: constants.REMOVE_JOB_DETAILS
    }
}

export function setCurrentLocation(currentLocation: {
    lat: number
    lng: number
}) {
    return {
        type: constants.CURRENT_LOCATION,
        currentLocation
    }
}

export function setZipCode(zipCode: string) {
    return {
        type: constants.ZIPCODE,
        zipCode
    }
}

export function setAdditionalItem(additionalItem: AdditionalItem) {
    return {
        type: constants.ADDITIONAL_ITEM,
        additionalItem
    }
}

export function setTimeMarks(marks: any) {
    return {
        type: constants.TIME_MARKS,
        marks
    }
}

export function setApartmentNumber(apartmentNumber: string) {
    return {
        type: constants.APARTMENT_NUMBER,
        apartmentNumber
    }
}

export function removeAllImages() {
    return {
        type: constants.REMOVE_ALL_IMAGES
    }
}

export function resetCheckboxes() {
    return {
        type: constants.RESET_CHECKBOXES
    }
}

export function statusChangedOnWeb() {
    return {
        type: constants.STATUS_CHANGED_ON_WEB
    }
}

export function saveTextareaHeight(minHeight: number) {
    return {
        type: constants.SAVE_TEXTAREA_HEIGHT,
        minHeight
    }
}

export function saveComplimentsNumber(complimentsNumber: ComplimentsNumber[]) {
    return {
        type: constants.COMPLIMENTS_NUMBER,
        complimentsNumber
    }
}

export function reschedule(isRescheduling: boolean) {
    return {
        type: constants.RESCHEDULE,
        isRescheduling
    }
}

export function setSlots(slots: Slots[]) {
    return {
        type: constants.SLOTS,
        slots
    }
}

export function setChips(chips: String[]) {
    return {
        type: constants.CHIPS,
        chips
    }
}

export function repostJob(job: Job, attachments: AttachmentParams[]) {
    return {
        type: constants.REPOST_JOB,
        job,
        attachments
    }
}

export function setJobTimeInfo(isJobTimeInfoShown: boolean) {
    return {
        type: constants.JOB_TIME_INFO,
        isJobTimeInfoShown
    }
}

export function setJobRequestId(jobRequestId: any) {
    return {
        type: constants.JOB_REQUEST_ID,
        jobRequestId
    }
}



// WEBPACK FOOTER //
// ./src/actions/setJobDetails.ts